export const iconData = [
    {
        iconClass: "fab fa-500px",
        text: "500px"
    },
    {
        iconClass: "fab fa-accessible-icon",
        text: "accessible-icon"
    },
    {
        iconClass: "fab fa-accusoft",
        text: "accusoft"
    },
    {
        iconClass: "fab fa-acquisitions-incorporated",
        text: "Incorporated"
    },
    {
        iconClass: "fas fa-ad",
        text: "ad"
    },
    {
        iconClass: "fas fa-address-book",
        text: "address-book"
    },
    {
        iconClass: "far fa-address-book",
        text: "address-book"
    },
    {
        iconClass: "fas fa-address-card",
        text: "address-card"
    },
    {
        iconClass: "far fa-address-card",
        text: "address-card"
    },
    {
        iconClass: "fas fa-adjust",
        text: "adjust"
    },
    {
        iconClass: "fab fa-adn",
        text: "adn"
    },
    {
        iconClass: "fab fa-adversal",
        text: "adversal"
    },
    {
        iconClass: "fab fa-affiliatetheme",
        text: "affiliatetheme"
    },
    {
        iconClass: "fas fa-air-freshener",
        text: "air-freshener"
    },
    {
        iconClass: "fab fa-algolia",
        text: "algolia"
    },
    {
        iconClass: "fas fa-align-center",
        text: "align-center"
    },
    {
        iconClass: "fas fa-align-justify",
        text: "align-justify"
    },
    {
        iconClass: "fas fa-align-left",
        text: "align-left"
    },
    {
        iconClass: "fas fa-align-right",
        text: "align-right"
    },
    {
        iconClass: "fab fa-alipay",
        text: "alipay"
    },
    {
        iconClass: "fas fa-allergies",
        text: "allergies"
    },
    {
        iconClass: "fab fa-amazon",
        text: "amazon"
    },
    {
        iconClass: "fab fa-amazon-pay",
        text: "amazon-pay"
    },
    {
        iconClass: "fas fa-ambulance",
        text: "ambulance"
    },
    {
        iconClass: "fab fa-amilia",
        text: "amilia"
    },
    {
        iconClass: "fas fa-anchor",
        text: "anchor"
    },
    {
        iconClass: "fas fa-angle-double-left",
        text: "angle-double-left"
    },
    {
        iconClass: "fab fa-angellist",
        text: "angellist"
    },
    {
        iconClass: "fab fa-android",
        text: "android"
    },
    {
        iconClass: "fas fa-angle-double-up",
        text: "angle-double-up"
    },
    {
        iconClass: "fas fa-angle-down",
        text: "angle-down"
    },
    {
        iconClass: "fas fa-angle-left",
        text: "angle-left"
    },
    {
        iconClass: "fas fa-angle-right",
        text: "angle-right"
    },
    {
        iconClass: "fas fa-angle-up",
        text: "angle-up"
    },
    {
        iconClass: "fas fa-angry",
        text: "angry"
    },
    {
        iconClass: "far fa-angry",
        text: "angry"
    },
    {
        iconClass: "fab fa-angrycreative",
        text: "angrycreative"
    },
    {
        iconClass: "fab fa-angular",
        text: "angular"
    },
    {
        iconClass: "fab fa-app-store",
        text: "app-store"
    },
    {
        iconClass: "fab fa-app-store-ios",
        text: "app-store-ios"
    },
    {
        iconClass: "fab fa-apple",
        text: "apple"
    },
    {
        iconClass: "fas fa-apple-alt",
        text: "apple-alt"
    },
    {
        iconClass: "fas fa-archive",
        text: "archive"
    },
    {
        iconClass: "fas fa-archway",
        text: "archway"
    },
    {
        iconClass: "far fa-arrow-alt-circle-left",
        text: "arrow-left"
    },
    {
        iconClass: "fas fa-arrow-alt-circle-right",
        text: "arrow-right"
    },
    {
        iconClass: "far fa-arrow-alt-circle-right",
        text: "arrow-right"
    },
    {
        iconClass: "far fa-arrow-alt-circle-up",
        text: "arrow-up"
    },
    {
        iconClass: "fas fa-arrow-circle-down",
        text: "arrow-down"
    },
    {
        iconClass: "fas fa-arrow-circle-left",
        text: "arrow-left"
    },
    {
        iconClass: "fas fa-arrow-circle-right",
        text: "arrow-right"
    },
    {
        iconClass: "fas fa-arrow-circle-up",
        text: "arrow-up"
    },
    {
        iconClass: "fas fa-arrow-down",
        text: "arrow-down"
    },
    {
        iconClass: "fas fa-arrow-left",
        text: "arrow-left"
    },
    {
        iconClass: "fas fa-arrow-right",
        text: "arrow-right"
    },
    {
        iconClass: "fas fa-arrow-up",
        text: "arrow-up"
    },
    {
        iconClass: "fas fa-arrows-alt",
        text: "arrows-alt"
    },
    {
        iconClass: "fas fa-arrows-alt-h",
        text: "arrows-alt-h"
    },
    {
        iconClass: "fas fa-arrows-alt-v",
        text: "arrows-alt-v"
    },
    {
        iconClass: "fas fa-asterisk",
        text: "asterisk"
    },
    {
        iconClass: "fab fa-asymmetrik",
        text: "asymmetrik"
    },
    {
        iconClass: "fas fa-at",
        text: "at"
    },
    {
        iconClass: "fas fa-atlas",
        text: "atlas"
    },
    {
        iconClass: "fas fa-atom",
        text: "atom"
    },
    {
        iconClass: "fab fa-audible",
        text: "audible"
    },
    {
        iconClass: "fab fa-autoprefixer",
        text: "autoprefixer"
    },
    {
        iconClass: "fab fa-avianex",
        text: "avianex"
    },
    {
        iconClass: "fas fa-award",
        text: "award"
    },
    {
        iconClass: "fab fa-aws",
        text: "aws"
    },
    {
        iconClass: "fas fa-backspace",
        text: "backspace"
    },
    {
        iconClass: "fas fa-backward",
        text: "backward"
    },
    {
        iconClass: "fas fa-ban",
        text: "ban"
    },
    {
        iconClass: "fas fa-band-aid",
        text: "band-aid"
    },
    {
        iconClass: "fab fa-bandcamp",
        text: "bandcamp"
    },
    {
        iconClass: "fas fa-barcode",
        text: "barcode"
    },
    {
        iconClass: "fas fa-bars",
        text: "bars"
    },
    {
        iconClass: "fas fa-baseball-ball",
        text: "baseball-ball"
    },
    {
        iconClass: "fas fa-basketball-ball",
        text: "basketball-ball"
    },
    {
        iconClass: "fas fa-bath",
        text: "bath"
    },
    {
        iconClass: "fas fa-battery-empty",
        text: "battery-empty"
    },
    {
        iconClass: "fas fa-battery-full",
        text: "battery-full"
    },
    {
        iconClass: "fas fa-battery-half",
        text: "battery-half"
    },
    {
        iconClass: "fas fa-battery-quarter",
        text: "battery-quarter"
    },
    {
        iconClass: "fas fa-bed",
        text: "bed"
    },
    {
        iconClass: "fas fa-beer",
        text: "beer"
    },
    {
        iconClass: "fab fa-behance-square",
        text: "behance-square"
    },
    {
        iconClass: "fas fa-bell",
        text: "bell"
    },
    {
        iconClass: "far fa-bell",
        text: "bell"
    },
    {
        iconClass: "fas fa-bell-slash",
        text: "bell-slash"
    },
    {
        iconClass: "far fa-bell-slash",
        text: "bell-slash"
    },
    {
        iconClass: "fas fa-bezier-curve",
        text: "bezier-curve"
    },
    {
        iconClass: "fas fa-bible",
        text: "bible"
    },
    {
        iconClass: "fas fa-bicycle",
        text: "bicycle"
    },
    {
        iconClass: "fab fa-bimobject",
        text: "bimobject"
    },
    {
        iconClass: "fas fa-binoculars",
        text: "binoculars"
    },
    {
        iconClass: "fas fa-birthday-cake",
        text: "birthday-cake"
    },
    {
        iconClass: "fab fa-bitbucket",
        text: "bitbucket"
    },
    {
        iconClass: "fab fa-bitcoin",
        text: "bitcoin"
    },
    {
        iconClass: "fab fa-bity",
        text: "bity"
    },
    {
        iconClass: "fab fa-black-tie",
        text: "black-tie"
    },
    {
        iconClass: "fab fa-blackberry",
        text: "blackberry"
    },
    {
        iconClass: "fas fa-blender",
        text: "blender"
    },
    {
        iconClass: "fas fa-blender-phone",
        text: "blender-phone"
    },
    {
        iconClass: "fab fa-blogger",
        text: "blogger"
    },
    {
        iconClass: "fab fa-blogger-b",
        text: "blogger-b"
    },
    {
        iconClass: "fab fa-bluetooth",
        text: "bluetooth"
    },
    {
        iconClass: "fab fa-bluetooth-b",
        text: "bluetooth-b"
    },
    {
        iconClass: "fas fa-bold",
        text: "bold"
    },
    {
        iconClass: "fas fa-bolt",
        text: "bolt"
    },
    {
        iconClass: "fas fa-bomb",
        text: "bomb"
    },
    {
        iconClass: "fas fa-bone",
        text: "bone"
    },
    {
        iconClass: "fas fa-bong",
        text: "bong"
    },
    {
        iconClass: "fas fa-calculator",
        text: "calculator"
    },
    {
        iconClass: "fas fa-calendar",
        text: "calendar"
    },
    {
        iconClass: "far fa-calendar-alt",
        text: "calendar-alt"
    },
    {
        iconClass: "far fa-calendar-minus",
        text: "calendar-minus"
    },
    {
        iconClass: "far fa-calendar-plus",
        text: "calendar-plus"
    },
    {
        iconClass: "fas fa-calendar-times",
        text: "calendar-times"
    },
    {
        iconClass: "fas fa-camera",
        text: "camera"
    },
    {
        iconClass: "fas fa-campground",
        text: "campground"
    },
    {
        iconClass: "fas fa-car",
        text: "car"
    },
    {
        iconClass: "fas fa-car-crash",
        text: "car-crash"
    },
    {
        iconClass: "fas fa-caret-down",
        text: "caret-down"
    },
    {
        iconClass: "fas fa-caret-left",
        text: "caret-left"
    },
    {
        iconClass: "fas fa-caret-right",
        text: "caret-right"
    },
    {
        iconClass: "fas fa-caret-up",
        text: "caret-up"
    },
    {
        iconClass: "fas fa-cart-arrow-down",
        text: "cart-arrow-down"
    },
    {
        iconClass: "fas fa-cart-plus",
        text: "cart-plus"
    },
    {
        iconClass: "fas fa-chalkboard",
        text: "chalkboard"
    },
    {
        iconClass: "fas fa-chart-area",
        text: "chart-area"
    },
    {
        iconClass: "fas fa-chart-pie",
        text: "chart-pie"
    },
    {
        iconClass: "fas fa-check",
        text: "check"
    },
    {
        iconClass: "fas fa-check-circle",
        text: "check-circle"
    },
    {
        iconClass: "fas fa-check-double",
        text: "check-double"
    },
    {
        iconClass: "fas fa-check-square",
        text: "check-square"
    },
    {
        iconClass: "fas fa-chess",
        text: "chess"
    },
    {
        iconClass: "fas fa-chevron-left",
        text: "chevron-left"
    },
    {
        iconClass: "fas fa-chevron-right",
        text: "chevron-right"
    },
    {
        iconClass: "fas fa-chevron-up",
        text: "chevron-up"
    },
    {
        iconClass: "fas fa-child",
        text: "child"
    },
    {
        iconClass: "fab fa-chrome",
        text: "chrome"
    },
    {
        iconClass: "fas fa-circle",
        text: "circle"
    },
    {
        iconClass: "fas fa-circle-notch",
        text: "circle-notch"
    },
    {
        iconClass: "fas fa-city",
        text: "city"
    },
    {
        iconClass: "fas fa-clipboard",
        text: "clipboard"
    },
    {
        iconClass: "fas fa-clipboard-check",
        text: "clipboard-check"
    },
    {
        iconClass: "fas fa-clock",
        text: "clock"
    },
    {
        iconClass: "fas fa-clone",
        text: "clone"
    },
    {
        iconClass: "fas fa-cloud-rain",
        text: "cloud-rain"
    },
    {
        iconClass: "fas fa-cloud-sun-rain",
        text: "cloud-sun-rain"
    },
    {
        iconClass: "fas fa-cloud-upload-alt",
        text: "cloud-upload-alt"
    },
    {
        iconClass: "fab fa-cloudsmith",
        text: "cloudsmith"
    },
    {
        iconClass: "fab fa-codepen",
        text: "codepen"
    },
    {
        iconClass: "fab fa-codiepie",
        text: "codiepie"
    },
    {
        iconClass: "fas fa-comment",
        text: "comment"
    },
    {
        iconClass: "fas fa-comment-dots",
        text: "comment-dots"
    },
    {
        iconClass: "fas fa-comments",
        text: "comments"
    },
    {
        iconClass: "fas fa-concierge-bell",
        text: "concierge-bell"
    },
    {
        iconClass: "fas fa-envelope",
        text: "envelope"
    },
    {
        iconClass: "far fa-envelope",
        text: "envelope"
    },
    {
        iconClass: "far fa-envelope-open",
        text: "envelope-open"
    },
    {
        iconClass: "fab fa-envira",
        text: "envira"
    },
    {
        iconClass: "fas fa-equals",
        text: "equals"
    },
    {
        iconClass: "fas fa-euro-sign",
        text: "euro-sign"
    },
    {
        iconClass: "far fa-eye-slash",
        text: "eye-slash"
    },
    {
        iconClass: "fab fa-facebook-f",
        text: "facebook-f"
    },
    {
        iconClass: "fas fa-fast-backward",
        text: "fast-backward"
    },
    {
        iconClass: "fas fa-female",
        text: "female"
    },
    {
        iconClass: "far fa-file",
        text: "file"
    },
    {
        iconClass: "fas fa-file-alt",
        text: "file"
    },
    {
        iconClass: "far fa-flushed",
        text: "flushed"
    },
    {
        iconClass: "fas fa-font",
        text: "font"
    },
    {
        iconClass: "far fa-frown",
        text: "frown"
    },
    {
        iconClass: "far fa-frown-open",
        text: "frown-open"
    },
    {
        iconClass: "fas fa-futbol",
        text: "futbol"
    },
    {
        iconClass: "fab fa-gg",
        text: "gg"
    },
    {
        iconClass: "fas fa-glass-martini",
        text: "glass-martini"
    },
    {
        iconClass: "fab fa-gofore",
        text: "gofore"
    },
    {
        iconClass: "fab fa-goodreads-g",
        text: "goodreads-g"
    },
    {
        iconClass: "fab fa-google",
        text: "google"
    },
    {
        iconClass: "fab fa-gratipay",
        text: "gratipay"
    },
    {
        iconClass: "fas fa-greater-than",
        text: "greater-than"
    },
    {
        iconClass: "fas fa-graduation-cap",
        text: "graduation-cap"
    },
    {
        iconClass: "fas fa-grin-hearts",
        text: "grin-hearts"
    },
    {
        iconClass: "far fa-grin-tongue",
        text: "grin-tongue"
    },
    {
        iconClass: "fas fa-grin-wink",
        text: "grin-wink"
    }
];
